import React, { memo, useCallback, useContext, useMemo, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import FileExplorerContext from '../../../contexts/FileExplorerContext';
import { deleteElement } from '../../../api/actions/Documents';
import { toast } from 'react-toastify';

const DeleteElementModal = ({ show, onClose, element }) => {
    const { onOpenFolder, fullPath, fetchFolderArchitecture } =
        useContext(FileExplorerContext);

    const [isLoading, setIsLoading] = useState(false);

    const descriptionText = useMemo(() => {
        if (element.isDirectory) {
            return (
                <span>
                    Are you sure that you want to delete the folder{' '}
                    <span style={{ fontWeight: 700 }}>{element.name}</span>? All
                    the files inside this folder will be permanently deleted.
                </span>
            );
        }

        return (
            <span>
                Are you sure that you want to delete the file{' '}
                <span style={{ fontWeight: 700 }}>{element.file.fileName}</span>
                ? It will be permanently deleted.
            </span>
        );
    }, [element]);

    const onDelete = useCallback(async () => {
        if (isLoading) {
            return;
        }

        setIsLoading(true);

        try {
            const currentFolder =
                fullPath.length === 0 ? '' : fullPath[fullPath.length - 1].id;

            await deleteElement(element.id);
            onOpenFolder(currentFolder);

            if (element.isDirectory) {
                fetchFolderArchitecture();
            }

            onClose();
        } catch (error) {
            console.error(error);
            toast.error(
                `Something went wrong while deleting the ${
                    element.isDirectory ? 'folder' : 'file'
                }. Please try again.`,
                {
                    className: 'custom-toast',
                }
            );
        } finally {
            setIsLoading(false);
        }
    }, [
        fullPath,
        onOpenFolder,
        isLoading,
        element,
        onClose,
        fetchFolderArchitecture,
    ]);

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>Delete folder</Modal.Header>
            <Modal.Body>
                {descriptionText}
                <div className="d-flex justify-content-end mt-4">
                    <Button variant="danger" onClick={onDelete}>
                        {isLoading ? <Spinner size="sm" /> : 'Delete'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default memo(DeleteElementModal);
